module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-outline', {
    attrs: {
      "title": 'Détails du document'
    }
  }, [_c('template', {
    slot: "pageContent"
  }, [(_vm.activateSpinner) ? _c('spinner') : _c('div', [_c('form-accordion', {
    attrs: {
      "title": 'Informations'
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "inputLabel": _vm.$t('common.type_doc'),
      "inputValue": _vm.entity.type_doc
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "inputLabel": _vm.$t('common.file_name'),
      "inputValue": _vm.entity.file_name
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "inputLabel": _vm.$t('common.date_label'),
      "inputValue": _vm.dateFormat(_vm.entity.end_time)
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "inputLabel": _vm.$t('common.errors'),
      "inputValue": 'Les champs suivants ont été retournés vides: ' + _vm.displayErrors(_vm.entity.errors)
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('form-accordion', {
    staticClass: "mt-5",
    attrs: {
      "title": 'Données collectées'
    }
  }, [_c('b-row', _vm._l((Object.entries(_vm.entity.json_data)), function(value, key) {
    return _c('b-col', {
      key: key,
      staticClass: "mt-2",
      attrs: {
        "sm": "4"
      }
    }, [_c('form-read-group-label-input', {
      attrs: {
        "inputLabel": _vm.$t('businessDocuments.serialize.' + _vm.entity.type_doc + '.' + value[0]),
        "inputValue": value[1]
      }
    })], 1)
  }), 1)], 1)], 1)], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-52594811", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52594811","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/detailPages/OCRScanDetailPage.vue
// module id = 2415
// module chunks = 2